module.exports = __webpack_public_path__ + "static/media/react.3ece720a.svg";